import me from "models/me";
import setLocale from "../lib/locale";

import { UNAUTHORIZED } from "constants/status-codes";

export default function (nextState, replace, callback) {
    if (me.session._id) {
        callback();
    } else {
        me.fetch({
            success() {
                // let event propagate
                process.nextTick(function () {
                    me.session._id = me._id;
                    me.session.trigger("sync");
                    setLocale(me.locale, () => {
                        callback();
                    });
                });
            },

            error(before, after, options) {
                setLocale(null, () => {
                    // expected response if not logged in
                    if (options.xhr.status === UNAUTHORIZED) {
                        const { accesstoken } = nextState.location.query;
                        if (accesstoken) {
                            const errorHandler = (err) => {
                                if (err) {
                                    const redirect = nextState.location.pathname + (nextState.location.search || "");
                                    replace({
                                        pathname: "/login",
                                        query: { redirect },
                                    });
                                }
                                callback();
                            };

                            me.loginPartially(accesstoken, errorHandler);
                        } else {
                            callback();
                        }
                    } else {
                        callback({
                            code: options.xhr.status || 500,
                            message: options.xhr.statusText || "Unknow Error",
                        });
                    }
                });
            },
        });
    }
}
